(function () {
  const headerMenuIcon = document.querySelector('.header__icon--menu');
  const headerHeightOutput = document.querySelector('.header-wrapper');
  const announcementOutput = document.querySelector('.announcement-bar-section');

  function updateHeaderHeight() {
    if (!headerHeightOutput || !announcementOutput) return;
    const getHeight = headerHeightOutput.offsetHeight;
    const getAnnouncementHeight = announcementOutput.offsetHeight;
    document.documentElement.style.setProperty('--header-height', `${getHeight}px`);
    document.documentElement.style.setProperty('--announcement-height', `${getAnnouncementHeight}px`);
  }

  if (headerMenuIcon) {
    headerMenuIcon.addEventListener('click', () => {
      const bodyMenu = document.querySelector('body');
      bodyMenu.classList.toggle('menu-open');
      updateHeaderHeight();
    });
  }

  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updateHeaderHeight, 100);
  });

  updateHeaderHeight();
})();

document.addEventListener('click', (event) => {
  const {target} = event;
  if (target.classList.contains('show-password') || target.classList.contains('hide-password')) {
    const parent = target.parentNode;
    const fieldId = parent.getAttribute('data-id');
    const field = document.getElementById(fieldId);
    if (target.classList.contains('show-password')) {
      parent.classList.add('show-password-active');
      field.type = 'text';
    } else {
      parent.classList.remove('show-password-active');
      field.type = 'password';
    }
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const cherryMode = document.querySelector('.cherry-mode-toggle');
  const bodyMenu = document.querySelector('body');

  // Function to update the body class based on the toggle state
  const updateCherryMode = () => {
    if (cherryMode.checked) {
      bodyMenu.classList.add('cherry-mode-active');
    } else {
      bodyMenu.classList.remove('cherry-mode-active');
    }
  };

  // Check the initial state
  if (cherryMode) {
    updateCherryMode();

    // Add event listener to toggle switch
    cherryMode.addEventListener('click', () => {
      bodyMenu.classList.toggle('cherry-mode-active');
    });
  }
});

// eslint-disable-next-line consistent-return
function initNewsletterForms(root = document) {
  const forms = root.querySelectorAll('#newsletter__form, #splash_page_form');

  forms.forEach((form) => {
    if (form.dataset.enhanced === 'true') return;
    // eslint-disable-next-line no-param-reassign
    form.dataset.enhanced = 'true';

    // eslint-disable-next-line consistent-return
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const container = form.closest('.newsletter__form') || form;
      const emailField = form.querySelector('input[name="contact[email]"]');
      const countryField = form.querySelector('select[name="contact[country]"]');
      const termsCheckbox = form.querySelector('input[name="newsletter-terms"]');

      const email = emailField ? emailField.value.trim() : '';
      const country = countryField ? countryField.value : '';

      function handleError(message) {
        const errorMessage =
          container.querySelector('.Newsletter-error--generic') ||
          form.querySelector('.Newsletter-error--generic');
        if (errorMessage) {
          errorMessage.textContent = message;
          errorMessage.style.display = 'block';
        }
      }

      if (!email || !country || country === 'Select a Country*') {
        handleError('Please fill in all required fields.');
        console.log('Error: Missing required fields.');
        return false;
      }

      if (termsCheckbox && !termsCheckbox.checked) {
        handleError('Please agree to the terms before subscribing.');
        console.log('Error: Terms not agreed.');
        return false;
      }

      const formData = new FormData();
      formData.append('contact[email]', email);
      formData.append('contact[country]', country);

      const xhr = new XMLHttpRequest();
      xhr.open('POST', 'https://sabrina-splash-page.mlinde.workers.dev/', true);

      xhr.onload = function() {
        if (xhr.status >= 200 && xhr.status < 300) {
          const successMessage =
            container.querySelector('.Newsletter-success--generic') ||
            form.querySelector('.Newsletter-success--generic');
          const errorMessage =
            container.querySelector('.Newsletter-error--generic') ||
            form.querySelector('.Newsletter-error--generic');
          const formElements = container.querySelectorAll('.cls-field');
          const hideAfterSubmitElements = container.querySelectorAll('.hide-after-submit');
          const termsElements = container.querySelector('.terms-agreement');

          if (successMessage) {
            successMessage.style.display = 'block';
            if (termsElements) termsElements.style.display = 'none';
            formElements.forEach((element) => {
              // eslint-disable-next-line no-param-reassign
              element.style.display = 'none';
            });

            hideAfterSubmitElements.forEach((element) => {
              // eslint-disable-next-line no-param-reassign
              element.style.display = 'none';
            });

            const sectionRoot = container.closest('.main-newsletter-signup');
            if (sectionRoot) {
              sectionRoot.classList.add('newsletter-submitted');
            }
          }
          if (errorMessage) {
            errorMessage.style.display = 'none';
          }
          form.reset(); // Clear the form on success
        } else {
          handleError('An error occurred. Please try again.');
        }
      };

      xhr.onerror = function() {
        let errorText = 'A network error occurred.';

        if (xhr.status === 400) {
          errorText = 'Your request was not accepted because you are outside of the United States.';
        } else if (xhr.status === 0) {
          errorText = 'It looks like you are offline. Please check your internet connection and try again.';
        } else {
          errorText += ` (Error code: ${xhr.status})`;
        }

        handleError(errorText);
      };

      xhr.onloadend = function() {
        const submitButton = form.querySelector('button[type="submit"]');
        if (submitButton) submitButton.disabled = false;
      };

      const submitButton = form.querySelector('button[type="submit"]');
      if (submitButton) submitButton.disabled = true;

      xhr.send(formData);
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initNewsletterForms();
});

document.addEventListener('shopify:section:load', (event) => {
  initNewsletterForms(event.target || document);
});


const countries = [
  {'name': 'United States', 'code': 'US'},
  {'name': 'Albania', 'code': 'AL'},
  {'name': 'Åland Islands', 'code': 'AX'},
  {'name': 'Algeria', 'code': 'DZ'},
  {'name': 'American Samoa', 'code': 'AS'},
  {'name': 'Andorra', 'code': 'AD'},
  {'name': 'Angola', 'code': 'AO'},
  {'name': 'Anguilla', 'code': 'AI'},
  {'name': 'Antarctica', 'code': 'AQ'},
  {'name': 'Antigua and Barbuda', 'code': 'AG'},
  {'name': 'Argentina', 'code': 'AR'},
  {'name': 'Armenia', 'code': 'AM'},
  {'name': 'Aruba', 'code': 'AW'},
  {'name': 'Australia', 'code': 'AU'},
  {'name': 'Austria', 'code': 'AT'},
  {'name': 'Azerbaijan', 'code': 'AZ'},
  {'name': 'Bahamas (the)', 'code': 'BS'},
  {'name': 'Bahrain', 'code': 'BH'},
  {'name': 'Bangladesh', 'code': 'BD'},
  {'name': 'Barbados', 'code': 'BB'},
  {'name': 'Belarus', 'code': 'BY'},
  {'name': 'Belgium', 'code': 'BE'},
  {'name': 'Belize', 'code': 'BZ'},
  {'name': 'Benin', 'code': 'BJ'},
  {'name': 'Bermuda', 'code': 'BM'},
  {'name': 'Bhutan', 'code': 'BT'},
  {'name': 'Bolivia (Plurinational State of)', 'code': 'BO'},
  {'name': 'Bonaire, Sint Eustatius and Saba', 'code': 'BQ'},
  {'name': 'Bosnia and Herzegovina', 'code': 'BA'},
  {'name': 'Botswana', 'code': 'BW'},
  {'name': 'Bouvet Island', 'code': 'BV'},
  {'name': 'Brazil', 'code': 'BR'},
  {'name': 'British Indian Ocean Territory (the)', 'code': 'IO'},
  {'name': 'Brunei Darussalam', 'code': 'BN'},
  {'name': 'Bulgaria', 'code': 'BG'},
  {'name': 'Burkina Faso', 'code': 'BF'},
  {'name': 'Burundi', 'code': 'BI'},
  {'name': 'Cabo Verde', 'code': 'CV'},
  {'name': 'Cambodia', 'code': 'KH'},
  {'name': 'Cameroon', 'code': 'CM'},
  {'name': 'Canada', 'code': 'CA'},
  {'name': 'Cayman Islands (the)', 'code': 'KY'},
  {'name': 'Central African Republic (the)', 'code': 'CF'},
  {'name': 'Chad', 'code': 'TD'},
  {'name': 'Chile', 'code': 'CL'},
  {'name': 'China', 'code': 'CN'},
  {'name': 'Christmas Island', 'code': 'CX'},
  {'name': 'Cocos (Keeling) Islands (the)', 'code': 'CC'},
  {'name': 'Colombia', 'code': 'CO'},
  {'name': 'Comoros (the)', 'code': 'KM'},
  {'name': 'Congo (the Democratic Republic of the)', 'code': 'CD'},
  {'name': 'Congo (the)', 'code': 'CG'},
  {'name': 'Cook Islands (the)', 'code': 'CK'},
  {'name': 'Costa Rica', 'code': 'CR'},
  {'name': 'Croatia', 'code': 'HR'},
  {'name': 'Cuba', 'code': 'CU'},
  {'name': 'Curaçao', 'code': 'CW'},
  {'name': 'Cyprus', 'code': 'CY'},
  {'name': 'Czechia', 'code': 'CZ'},
  {'name': 'Côte d`Ivoire', 'code': 'CI'},
  {'name': 'Denmark', 'code': 'DK'},
  {'name': 'Djibouti', 'code': 'DJ'},
  {'name': 'Dominica', 'code': 'DM'},
  {'name': 'Dominican Republic (the)', 'code': 'DO'},
  {'name': 'Ecuador', 'code': 'EC'},
  {'name': 'Egypt', 'code': 'EG'},
  {'name': 'El Salvador', 'code': 'SV'},
  {'name': 'Equatorial Guinea', 'code': 'GQ'},
  {'name': 'Eritrea', 'code': 'ER'},
  {'name': 'Estonia', 'code': 'EE'},
  {'name': 'Eswatini', 'code': 'SZ'},
  {'name': 'Ethiopia', 'code': 'ET'},
  {'name': 'Falkland Islands (the) [Malvinas]', 'code': 'FK'},
  {'name': 'Faroe Islands (the)', 'code': 'FO'},
  {'name': 'Fiji', 'code': 'FJ'},
  {'name': 'Finland', 'code': 'FI'},
  {'name': 'France', 'code': 'FR'},
  {'name': 'French Guiana', 'code': 'GF'},
  {'name': 'French Polynesia', 'code': 'PF'},
  {'name': 'French Southern Territories (the)', 'code': 'TF'},
  {'name': 'Gabon', 'code': 'GA'},
  {'name': 'Gambia (the)', 'code': 'GM'},
  {'name': 'Georgia', 'code': 'GE'},
  {'name': 'Germany', 'code': 'DE'},
  {'name': 'Ghana', 'code': 'GH'},
  {'name': 'Gibraltar', 'code': 'GI'},
  {'name': 'Greece', 'code': 'GR'},
  {'name': 'Greenland', 'code': 'GL'},
  {'name': 'Grenada', 'code': 'GD'},
  {'name': 'Guadeloupe', 'code': 'GP'},
  {'name': 'Guam', 'code': 'GU'},
  {'name': 'Guatemala', 'code': 'GT'},
  {'name': 'Guernsey', 'code': 'GG'},
  {'name': 'Guinea', 'code': 'GN'},
  {'name': 'Guinea-Bissau', 'code': 'GW'},
  {'name': 'Guyana', 'code': 'GY'},
  {'name': 'Haiti', 'code': 'HT'},
  {'name': 'Heard Island and McDonald Islands', 'code': 'HM'},
  {'name': 'Holy See (the)', 'code': 'VA'},
  {'name': 'Honduras', 'code': 'HN'},
  {'name': 'Hong Kong', 'code': 'HK'},
  {'name': 'Hungary', 'code': 'HU'},
  {'name': 'Iceland', 'code': 'IS'},
  {'name': 'India', 'code': 'IN'},
  {'name': 'Indonesia', 'code': 'ID'},
  {'name': 'Iran (Islamic Republic of)', 'code': 'IR'},
  {'name': 'Iraq', 'code': 'IQ'},
  {'name': 'Ireland', 'code': 'IE'},
  {'name': 'Isle of Man', 'code': 'IM'},
  {'name': 'Israel', 'code': 'IL'},
  {'name': 'Italy', 'code': 'IT'},
  {'name': 'Jamaica', 'code': 'JM'},
  {'name': 'Japan', 'code': 'JP'},
  {'name': 'Jersey', 'code': 'JE'},
  {'name': 'Jordan', 'code': 'JO'},
  {'name': 'Kazakhstan', 'code': 'KZ'},
  {'name': 'Kenya', 'code': 'KE'},
  {'name': 'Kiribati', 'code': 'KI'},
  {'name': 'Korea (the Democratic People`s Republic of)', 'code': 'KP'},
  {'name': 'Korea (the Republic of)', 'code': 'KR'},
  {'name': 'Kuwait', 'code': 'KW'},
  {'name': 'Kyrgyzstan', 'code': 'KG'},
  {'name': 'Lao People`s Democratic Republic (the)', 'code': 'LA'},
  {'name': 'Latvia', 'code': 'LV'},
  {'name': 'Lebanon', 'code': 'LB'},
  {'name': 'Lesotho', 'code': 'LS'},
  {'name': 'Liberia', 'code': 'LR'},
  {'name': 'Libya', 'code': 'LY'},
  {'name': 'Liechtenstein', 'code': 'LI'},
  {'name': 'Lithuania', 'code': 'LT'},
  {'name': 'Luxembourg', 'code': 'LU'},
  {'name': 'Macao', 'code': 'MO'},
  {'name': 'Madagascar', 'code': 'MG'},
  {'name': 'Malawi', 'code': 'MW'},
  {'name': 'Malaysia', 'code': 'MY'},
  {'name': 'Maldives', 'code': 'MV'},
  {'name': 'Mali', 'code': 'ML'},
  {'name': 'Malta', 'code': 'MT'},
  {'name': 'Marshall Islands (the)', 'code': 'MH'},
  {'name': 'Martinique', 'code': 'MQ'},
  {'name': 'Mauritania', 'code': 'MR'},
  {'name': 'Mauritius', 'code': 'MU'},
  {'name': 'Mayotte', 'code': 'YT'},
  {'name': 'Mexico', 'code': 'MX'},
  {'name': 'Micronesia (Federated States of)', 'code': 'FM'},
  {'name': 'Moldova (the Republic of)', 'code': 'MD'},
  {'name': 'Monaco', 'code': 'MC'},
  {'name': 'Mongolia', 'code': 'MN'},
  {'name': 'Montenegro', 'code': 'ME'},
  {'name': 'Montserrat', 'code': 'MS'},
  {'name': 'Morocco', 'code': 'MA'},
  {'name': 'Mozambique', 'code': 'MZ'},
  {'name': 'Myanmar', 'code': 'MM'},
  {'name': 'Namibia', 'code': 'NA'},
  {'name': 'Nauru', 'code': 'NR'},
  {'name': 'Nepal', 'code': 'NP'},
  {'name': 'Netherlands (the)', 'code': 'NL'},
  {'name': 'New Caledonia', 'code': 'NC'},
  {'name': 'New Zealand', 'code': 'NZ'},
  {'name': 'Nicaragua', 'code': 'NI'},
  {'name': 'Niger (the)', 'code': 'NE'},
  {'name': 'Nigeria', 'code': 'NG'},
  {'name': 'Niue', 'code': 'NU'},
  {'name': 'Norfolk Island', 'code': 'NF'},
  {'name': 'Northern Mariana Islands (the)', 'code': 'MP'},
  {'name': 'Norway', 'code': 'NO'},
  {'name': 'Oman', 'code': 'OM'},
  {'name': 'Pakistan', 'code': 'PK'},
  {'name': 'Palau', 'code': 'PW'},
  {'name': 'Palestine, State of', 'code': 'PS'},
  {'name': 'Panama', 'code': 'PA'},
  {'name': 'Papua New Guinea', 'code': 'PG'},
  {'name': 'Paraguay', 'code': 'PY'},
  {'name': 'Peru', 'code': 'PE'},
  {'name': 'Philippines (the)', 'code': 'PH'},
  {'name': 'Pitcairn', 'code': 'PN'},
  {'name': 'Poland', 'code': 'PL'},
  {'name': 'Portugal', 'code': 'PT'},
  {'name': 'Puerto Rico', 'code': 'PR'},
  {'name': 'Qatar', 'code': 'QA'},
  {'name': 'Republic of North Macedonia', 'code': 'MK'},
  {'name': 'Romania', 'code': 'RO'},
  {'name': 'Russian Federation (the)', 'code': 'RU'},
  {'name': 'Rwanda', 'code': 'RW'},
  {'name': 'Réunion', 'code': 'RE'},
  {'name': 'Saint Barthélemy', 'code': 'BL'},
  {'name': 'Saint Helena, Ascension and Tristan da Cunha', 'code': 'SH'},
  {'name': 'Saint Kitts and Nevis', 'code': 'KN'},
  {'name': 'Saint Lucia', 'code': 'LC'},
  {'name': 'Saint Martin (French part)', 'code': 'MF'},
  {'name': 'Saint Pierre and Miquelon', 'code': 'PM'},
  {'name': 'Saint Vincent and the Grenadines', 'code': 'VC'},
  {'name': 'Samoa', 'code': 'WS'},
  {'name': 'San Marino', 'code': 'SM'},
  {'name': 'Sao Tome and Principe', 'code': 'ST'},
  {'name': 'Saudi Arabia', 'code': 'SA'},
  {'name': 'Senegal', 'code': 'SN'},
  {'name': 'Serbia', 'code': 'RS'},
  {'name': 'Seychelles', 'code': 'SC'},
  {'name': 'Sierra Leone', 'code': 'SL'},
  {'name': 'Singapore', 'code': 'SG'},
  {'name': 'Sint Maarten (Dutch part)', 'code': 'SX'},
  {'name': 'Slovakia', 'code': 'SK'},
  {'name': 'Slovenia', 'code': 'SI'},
  {'name': 'Solomon Islands', 'code': 'SB'},
  {'name': 'Somalia', 'code': 'SO'},
  {'name': 'South Africa', 'code': 'ZA'},
  {'name': 'South Georgia and the South Sandwich Islands', 'code': 'GS'},
  {'name': 'South Sudan', 'code': 'SS'},
  {'name': 'Spain', 'code': 'ES'},
  {'name': 'Sri Lanka', 'code': 'LK'},
  {'name': 'Sudan (the)', 'code': 'SD'},
  {'name': 'Suriname', 'code': 'SR'},
  {'name': 'Svalbard and Jan Mayen', 'code': 'SJ'},
  {'name': 'Sweden', 'code': 'SE'},
  {'name': 'Switzerland', 'code': 'CH'},
  {'name': 'Syrian Arab Republic', 'code': 'SY'},
  {'name': 'Taiwan (Province of China)', 'code': 'TW'},
  {'name': 'Tajikistan', 'code': 'TJ'},
  {'name': 'Tanzania, United Republic of', 'code': 'TZ'},
  {'name': 'Thailand', 'code': 'TH'},
  {'name': 'Timor-Leste', 'code': 'TL'},
  {'name': 'Togo', 'code': 'TG'},
  {'name': 'Tokelau', 'code': 'TK'},
  {'name': 'Tonga', 'code': 'TO'},
  {'name': 'Trinidad and Tobago', 'code': 'TT'},
  {'name': 'Tunisia', 'code': 'TN'},
  {'name': 'Turkey', 'code': 'TR'},
  {'name': 'Turkmenistan', 'code': 'TM'},
  {'name': 'Turks and Caicos Islands (the)', 'code': 'TC'},
  {'name': 'Tuvalu', 'code': 'TV'},
  {'name': 'Uganda', 'code': 'UG'},
  {'name': 'Ukraine', 'code': 'UA'},
  {'name': 'United Arab Emirates (the)', 'code': 'AE'},
  {'name': 'United Kingdom of Great Britain and Northern Ireland (the)', 'code': 'GB'},
  {'name': 'United States Minor Outlying Islands (the)', 'code': 'UM'},
  {'name': 'Uruguay', 'code': 'UY'},
  {'name': 'Uzbekistan', 'code': 'UZ'},
  {'name': 'Vanuatu', 'code': 'VU'},
  {'name': 'Venezuela (Bolivarian Republic of)', 'code': 'VE'},
  {'name': 'Viet Nam', 'code': 'VN'},
  {'name': 'Virgin Islands (British)', 'code': 'VG'},
  {'name': 'Virgin Islands (U.S.)', 'code': 'VI'},
  {'name': 'Wallis and Futuna', 'code': 'WF'},
  {'name': 'Western Sahara', 'code': 'EH'},
  {'name': 'Yemen', 'code': 'YE'},
  {'name': 'Zambia', 'code': 'ZM'},
  {'name': 'Zimbabwe', 'code': 'ZW'}
];

const selectCountries = document.querySelectorAll('.country_list');

selectCountries.forEach((selectCountry) => {
  countries.forEach((country) => {
    const opt = document.createElement('option');
    opt.value = country.code;
    opt.innerHTML = country.name;
    selectCountry.appendChild(opt);
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const sizeOptions = document.querySelectorAll('.product-size-option');

  if (sizeOptions.length > 0) {
    sizeOptions.forEach((sizeOption) => {
      sizeOption.addEventListener('change', function() {
        const productDiv = this.closest('.quick-add');
        const currentId = productDiv.querySelector('.hidden-variant-id');
        const variantId = this.getAttribute('data-variant-id');
        currentId.value = variantId;
      });
    });
  }
});

function activateElements(dot, content) {
  const productDots = document.querySelectorAll('.product-dot');
  const accordianContents = document.querySelectorAll('.product-notes-accordian-content');

  // Remove 'active' and 'close' class from all dots and contents
  productDots.forEach(dot => {
    dot.classList.remove('active');
    dot.classList.add('close');
  });
  accordianContents.forEach(content => {
    content.classList.remove('active');
    content.classList.add('close');
  });

  // Add 'active' class to specified dot and content, and remove 'close' class
  dot.classList.add('active');
  dot.classList.remove('close');
  content.classList.add('active');
  content.classList.remove('close');
}

function productNotesToggleItem() {
  const productNotesAccItem = document.getElementsByClassName('product-notes-accordian-content');
  const productNotesClass = this.parentNode.className;
  for (let i = 0; i < productNotesAccItem.length; i++) {
    productNotesAccItem[i].className = 'product-notes-accordian-content close';
  }
  if (productNotesClass === 'product-notes-accordian-content close') {
    this.parentNode.className = 'product-notes-accordian-content active';
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const productDots = document.querySelectorAll('.product-dot');
  const accordianContents = document.querySelectorAll('.product-notes-accordian-content');

  if (productDots.length && accordianContents.length) {
    productDots.forEach(dot => {
      dot.addEventListener('click', function() {
        const targetId = this.id;
        const targetContent = document.querySelector(`.product-notes-accordian-content[data-id="${targetId}"]`);
        activateElements(this, targetContent);
      });
    });

    accordianContents.forEach(content => {
      content.addEventListener('click', function() {
        const targetId = this.getAttribute('data-id');
        const targetDot = document.querySelector(`#${targetId}`);
        activateElements(targetDot, this);
      });
    });
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const productNotesAccItem = document.getElementsByClassName('product-notes-accordian-content');
  const productNotesHeading = document.getElementsByClassName('product-notes-heading-accordian');

  if (productNotesAccItem.length && productNotesHeading.length) {
    // Add click event listener to each heading
    for (let i = 0; i < productNotesHeading.length; i++) {
      productNotesHeading[i].addEventListener('click', productNotesToggleItem, false);
    }

    // Set the first accordion item to be active by default
    if (productNotesAccItem.length > 0) {
      productNotesAccItem[0].classList.add('active');
      productNotesAccItem[0].classList.remove('close');
    }
  }
});

// Initialize variables at the top level for scoping
let acc;
let accItem;
let accHD;

document.addEventListener('DOMContentLoaded', () => {
  // Define variables within DOMContentLoaded listener to ensure DOM is loaded
  acc = document.getElementsByClassName('section-collection-faq');
  accItem = document.getElementsByClassName('faq-item');
  accHD = document.getElementsByClassName('faq-item-heading');

  // Function to toggle FAQ items
  function toggleItem() {
    const itemClass = this.parentNode.className;
    for (let i = 0; i < accItem.length; i++) {
      accItem[i].className = 'faq-item close';
    }
    if (itemClass === 'faq-item close') {
      this.parentNode.className = 'faq-item open';
    }
  }

  // Add a click event listener to each FAQ item heading
  for (let i = 0; i < accHD.length; i++) {
    accHD[i].addEventListener('click', toggleItem, false);
  }

  // If there are no FAQ items but there is an FAQ section, remove the section
  if (accItem && accItem.length <= 0 && acc && acc.length) {
    document.querySelector('.section-collection-faq').remove();
  }

  // Set the first accordion item to be open by default
  for (let i = 0; i < accItem.length; i++) {
    if (i === 0) {
      accItem[i].classList.add('open');
      accItem[i].classList.remove('close');
    }
  }
});

document.addEventListener('DOMContentLoaded', () => {
  function getVideoAttributes(isMobile, videoContainer) {
    return {
      videoSource: isMobile ? videoContainer.getAttribute('data-mobile-video') : videoContainer.getAttribute('data-desktop-video'),
      posterImage: isMobile ? videoContainer.getAttribute('data-mobile-video-poster') : videoContainer.getAttribute('data-desktop-video-poster'),
    };
  }

  function updateVideoElement(videoElement, videoSource, posterImage) {
    const sourceElement = videoElement.querySelector('source');
    if (sourceElement && sourceElement.getAttribute('src') !== videoSource) {
      sourceElement.setAttribute('src', videoSource);
      videoElement.load();
    }
    if (posterImage && videoElement.getAttribute('poster') !== posterImage) {
      videoElement.setAttribute('poster', posterImage);
    }
  }

  function updatePosterImage(videoContainer, posterImage) {
    const posterImageElement = videoContainer.querySelector('video > img');
    if (posterImageElement && posterImageElement.getAttribute('src') !== posterImage) {
      posterImageElement.setAttribute('src', posterImage);
    }
  }

  function updateVideoSource() {
    const videoContainer = document.querySelector('.bg-cover-video');
    if (!videoContainer) return;

    const isMobile = window.innerWidth < 767;
    const { videoSource, posterImage } = getVideoAttributes(isMobile, videoContainer);
    if (!videoSource) return;

    const videoElement = videoContainer.querySelector('video');
    if (videoElement) {
      updateVideoElement(videoElement, videoSource, posterImage);
    }
    updatePosterImage(videoContainer, posterImage);
  }

  function debounce(func, wait) {
    let timeout;
    return function () {
      const context = this; const args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  }

  const debouncedUpdateVideoSource = debounce(updateVideoSource, 100);

  updateVideoSource();
  window.addEventListener('resize', debouncedUpdateVideoSource);
});

function observeGeolocationModal() {
  const observer = new MutationObserver(() => {
    const geoMsg = document.querySelector('.spicegems_geolocation_mod_msg');

    if (geoMsg && getComputedStyle(geoMsg).display === 'block') {
      // Define a function to update the height variable
      const updateHeight = () => {
        const height = geoMsg.offsetHeight;
        document.documentElement.style.setProperty('--geolocation-modal-message-height', `${height + 16}px`);
      };

      // Initial height set
      updateHeight();

      // Listen for window resize and update height
      window.addEventListener('resize', updateHeight);

      observer.disconnect(); // Stop observing DOM changes
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

observeGeolocationModal();


/* eslint-disable */

var collectionSliderSwiper = new Swiper('.collection-slider', {
  slidesPerView: 1.5,
  spaceBetween: 8,
  loop: true,
  draggable: true,
  cssMode: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
    enabled: false
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
    enabled: true
  },
  breakpoints: {
    768: {
      spaceBetween: 24,
      navigation: {
        enabled: true
      }
    }
  }
});

var productSliderSwiper = new Swiper('.product-slider', {
  slidesPerView: 1.75,
  spaceBetween: 8,
  loop: true,
  cssMode: true,
  draggable: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
    enabled: false
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
    enabled: true
  },
  breakpoints: {
    768: {
      slidesPerView: 3,
      spaceBetween: 24,
      loop: false,
      navigation: {
        enabled: true
      }
    },
    1025: {
      slidesPerView: 4,
      spaceBetween: 24,
      loop: false,
      navigation: {
        enabled: true
      }
    }
  }
});

function swiperCategoriesCard() {
  let initCategoriesSlider = false;
  let swiperCategoriesSlider;

  function initializeSwiper() {
    if (window.innerWidth >= 768) {
      if (!initCategoriesSlider) {
        initCategoriesSlider = true;
        swiperCategoriesSlider = new Swiper(".categories-slider", {
          slidesPerView: 2,
          spaceBetween: 12,
          loop: true,
          cssMode: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
            enabled: false
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
            enabled: true
          },
          breakpoints: {
            768: {
              slidesPerView: 3,
              spaceBetween: 24,
              navigation: {
                enabled: true
              }
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 24,
              navigation: {
                enabled: true
              }
            }
          }
        });
      }
    } else {
      if (initCategoriesSlider) {
        swiperCategoriesSlider.destroy();
        initCategoriesSlider = false;
      }
    }
  }

  // Initialize on page load
  initializeSwiper();

  // Reinitialize on window resize
  window.addEventListener("resize", initializeSwiper);
}

swiperCategoriesCard();

/* eslint-enable */



// Accessibility fixes
(function () {
  let isProcessing = false;

  function processAccessibeWidgets() {
    document.querySelectorAll('access-widget-ui').forEach(widget => {
      if (!widget.shadowRoot) return;

      try {
        widget.shadowRoot.querySelectorAll('[data-acsb="skipLinks"]')
          .forEach(el => el.remove());

        const trigger = widget.shadowRoot.querySelector('.acsb-trigger.acsb-widget[role="button"]');
        if (trigger) trigger.removeAttribute('role');
      } catch (error) {
        console.warn('Shadow DOM access failed:', error);
      }
    });
  }

  function processLightDomTrigger() {
    const trigger = document.querySelector('.acsb-trigger.acsb-widget[role="button"]');
    if (trigger) trigger.removeAttribute('role');
  }

  function processDownShift() {
    const downShiftDiv = document.querySelector('#downshift-0-menu');
    if (downShiftDiv) {
      downShiftDiv.removeAttribute('role');
    }
  }

  function fixAccessibilityIssues() {
    if (isProcessing) return;
    isProcessing = true;

    processAccessibeWidgets();
    processLightDomTrigger();
    processDownShift();
    isProcessing = false;
  }

  document.addEventListener('DOMContentLoaded', fixAccessibilityIssues);
  window.addEventListener('load', () => setTimeout(fixAccessibilityIssues, 500));

  [500, 1000, 2000, 3000].forEach(delay =>
    setTimeout(fixAccessibilityIssues, delay)
  );

  new MutationObserver(mutations => {
    if (mutations.some(m => m.addedNodes.length > 0)) {
      setTimeout(fixAccessibilityIssues, 100);
    }
  }).observe(document.body, { childList: true, subtree: true });
})();